import { Trip } from 'services/SwaggerApi';

export const isConferenceTrip = (trip: Trip) => (trip.purposes || []).some(({ kind }) => ['conf_internal', 'conf_external'].includes(kind));
